import { ELLIPSIS, getPageNumbers } from '@shared/ui/pagination';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { ArrowIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { useMemo } from 'react';

interface PaginationProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  totalPage: number;
  handlePrevPage: () => void;
  handleNextPage: () => void;
  visible?: boolean;
  containerClassName?: string;
}

export const Pagination = ({
  currentPage,
  onPageChange,
  totalPage,
  handlePrevPage,
  handleNextPage,
  visible = true,
  containerClassName,
}: PaginationProps) => {
  const pageNumbers = useMemo(() => getPageNumbers(totalPage, currentPage), [totalPage, currentPage]);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPage;
  const paginationClassName = [containerClassName, stylex.props(styles.pagination).className].join(' ');

  if (!visible) return;

  return (
    <div className={paginationClassName}>
      <UnstyledButton
        disabled={isFirstPage}
        onClick={handlePrevPage}
        {...stylex.props(styles.paginationArrow, styles.paginationArrowLeft)}
      >
        <ArrowIcon />
      </UnstyledButton>

      {pageNumbers?.map((pageNumber, index) => (
        <UnstyledButton
          key={`${pageNumber}-${index}`}
          disabled={pageNumber === ELLIPSIS}
          onClick={() => onPageChange(Number(pageNumber))}
          {...stylex.props(styles.paginationItem, currentPage === pageNumber && styles.paginationItemActive)}
        >
          {pageNumber}
        </UnstyledButton>
      ))}

      <UnstyledButton disabled={isLastPage} onClick={handleNextPage} {...stylex.props(styles.paginationArrow)}>
        <ArrowIcon />
      </UnstyledButton>
    </div>
  );
};
